<div class="partner-area ptb-70 bg-fffdfd">
    <div class="container">
        <div class="partner-slides">
            <owl-carousel-o [options]="partnerSlides">
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_1.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_2.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_3.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_4.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_5.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_6.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_7.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="partner-item">
                        <a href="#" target="_blank"
                            ><img src="assets/home/tech_8.png" alt="partner"
                        /></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
